import { Button } from "@mantine/core";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { usePostApi } from "src/hooks";
import { type Stamp } from "src/interfaces/Stamps";
import { useDispatch } from "src/redux/hooks";
import { setStampsModalProps } from "src/redux/slices/generatorSlice";
import { StyledTd, StyledTr } from "src/styled";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

interface Props extends Stamp {
  refetchStamps: () => void;
  handleOpenHistoryModal: () => void;
}

const ShipsStampsListItem = ({
  stampid,
  logbooks,
  name,
  data,
  refetchStamps,
  handleOpenHistoryModal,
}: Props) => {
  const dispatch = useDispatch();

  const { post } = usePostApi();

  const deleteRow = async () => {
    await post({
      request: "remove-stamp",
      body: { params: { yachtid: getYachtId(), stampid } },
      onSuccess: () => {
        Notification("Success", "Stamp has been successfully removed", "green");
        refetchStamps();
      },
    });
  };
  const handleEdit = () => {
    dispatch(
      setStampsModalProps({
        opened: true,
        stampid,
      }),
    );
  };
  return (
    <StyledTr key={stampid}>
      <StyledTd style={{ textAlign: "center", maxWidth: "200px" }}>
        {name}
      </StyledTd>
      <StyledTd style={{ textAlign: "center", maxWidth: "120px" }}>
        <img src={`data:image/png;base64, ${data}`} alt="" width="100" />
      </StyledTd>
      <StyledTd>{logbooks.join(", ")}</StyledTd>
      <StyledTd>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Button onClick={handleEdit} variant="outline" size="xs">
            Edit
          </Button>
          <Button onClick={handleOpenHistoryModal} variant="outline" size="xs">
            History
          </Button>
          <ConfirmationButton
            modalText="Are you sure you wish to remove this stamp?"
            onConfirm={deleteRow}
            buttonProps={{
              size: "xs",
              variant: "outline",
              color: "red",
            }}>
            Delete
          </ConfirmationButton>
        </div>
      </StyledTd>
    </StyledTr>
  );
};
export default ShipsStampsListItem;
